import EmptyState from '../components/EmptyState';

export default function Abc() {
  return (
    <EmptyState
      title="Alphabet"
      description="Alphabet course content -- exists at abc.glossika.com"
    />
  );
}
